export default __webpack_public_path__ + "static/media/freeMinting.864595c3.png";